import { Button, SvgIcon } from '@mui/material';
import PlusCircleIcon from 'mdi-react/PlusCircleIcon';
import React from 'react';
import { I18n } from 'utils/i18n';

const AddFormatButton = props => {
  return (
    <Button variant="contained" color="primary" {...props}>
      <SvgIcon sx={{ fontSize: 18, mr: '5px' }}>
        <PlusCircleIcon />
      </SvgIcon>
      {I18n.t('HrBot.New template')}
    </Button>
  );
};

export default AddFormatButton;
